import React, { useState } from "react";
import { Checkbox, Typography } from "@mui/material";
import Plot from "react-plotly.js";
import { baseURL } from "../Config/config";
import GlobalLoader from "./CommonC/GlobalLoader";
import Box from "@mui/material/Box";
import Projectcolors from "../Utils/Colors";
import { Grid, Paper, TextField } from "@mui/material";
import Radio from "@mui/material/Radio";


function Spearman() {
  const [ranks, setRanks] = React.useState([]);
  const [independent, setIndependent] = React.useState([]);
  const [dependent, setdependent] = React.useState([]);
  const [getLoader , setGetLoader] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState(0);

  

  const handleChange = (item,position) => {
    setSelectedValue(position);
  };




    React.useEffect(() => {
        getSpearman()
      }, []);

      const getSpearman = () => { 
        setGetLoader(true);
        const ProjectID = sessionStorage.getItem("projectID")
        fetch(`${baseURL}/getSpearman?projectID=${ProjectID}`)
          .then((res) => res.json())
          .then((myresponse) => {
           setRanks(myresponse.allranks);
           setIndependent(myresponse.independent);
           setdependent(myresponse.dependent);
           setGetLoader(false);
           
           console.log(myresponse);

          })
          .catch((err)=> {
            setGetLoader(false);
            console.log("error",err)})
       }

        
       
  return (
  <Box
    sx={{
      display: "flex",
      gap: 2,
      width: "100%",
      height: "100%",
    }}
  >
    {/* Left Variable Panel */}
    <Paper
      elevation={0}
      sx={{
        width: "25%",
        minWidth: "240px",
        height: "500px",
        borderRadius: "22px",
        overflow: "hidden",
        boxShadow: "0px 6px 24px rgba(0,0,0,.06)",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          bgcolor: "#0078c9",
          color: "#fff",
          px: 2,
          py: 1.5,
        }}
      >
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 600,
          }}
        >
          Dependent Variables
        </Typography>
      </Box>

      {/* Radio List */}
      <Box
        sx={{
          overflowY: "auto",
          height: "430px",
          p: 1,
        }}
      >
        {dependent?.map((item, i) => (
          <Box
            key={i}
            sx={{
              display: "flex",
              alignItems: "center",
              px: 1,
              py: .6,
              borderRadius: "14px",
              cursor: "pointer",

              transition: ".2s",

              "&:hover": {
                bgcolor: "rgba(0,120,201,.05)"
              }
            }}
          >
            <Radio
              checked={selectedValue === i}
              onChange={() => handleChange(item, i)}
              value={i}
              sx={{
                color: "#0078c9",

                "&.Mui-checked": {
                  color: "#9e0b22",
                },
              }}
            />

            <Typography
              sx={{
                fontSize: "12px",
              }}
            >
              {item}
            </Typography>
          </Box>
        ))}
      </Box>
    </Paper>

    {/* Plot Card */}
    <Paper
      elevation={0}
      sx={{
        flex: 1,
        p: 2,
        borderRadius: "22px",
        boxShadow: "0px 6px 24px rgba(0,0,0,.06)",
      }}
    >
      <Typography
        sx={{
          fontSize: "12px",
          fontWeight: 600,
          color: "#0078c9",
          mb: 2,
        }}
      >
        MB Ranking Plot
      </Typography>

      <Plot
        data={[
          {
            x: independent,
            y: ranks[selectedValue],
            type: "bar",

            marker: {
              color: "#0078c9",
            },

            width: 0.35,
          },
        ]}
        layout={{
          autosize: true,

          margin: {
            l: 50,
            r: 20,
            b: 80,
            t: 20,
          },

          xaxis: {
            automargin: true,
          },

          yaxis: {
            automargin: true,
          },

          paper_bgcolor: "white",
          plot_bgcolor: "white",
        }}
        useResizeHandler={true}
        style={{
          width: "100%",
          height: "430px",
        }}
        config={{
          responsive: true,
          displaylogo: false,
        }}
      />
    </Paper>

    {getLoader && <GlobalLoader />}
  </Box>
);
}

export default Spearman